import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m13.542 34.375 2.968-2.917-4.375-4.375H43.75v-4.166H12.135l4.323-4.375-2.968-2.917L4.167 25z" }, null, -1)
  ]))]))
}
export default { render: render }